<template>
  <div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <b-tabs content-class class="navtab-bg">
            <b-tab title="Solicitações" active
              @click="fetchWithdrawls('REQUESTED')"
            >
              <div class="row">
                <!-- Items per page -->
                <div class="col-sm-12 col-md-6">
                  <div class="row align-items-center">
                    <div class="col-2 m-0">Mostrar&nbsp;</div>
                    <div class="col-3 m-0 p-0">
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="fetchWithdrawls('REQUESTED')"
                      ></b-form-select>
                    </div>
                    <div class="col-3 m-0 p-0">&nbsp;por página</div>
                  </div>
                </div>

                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="search"
                        type="search"
                        placeholder="Pesquisar..."
                        class="form-control form-control-sm ml-2"
                        @input="fetchWithdrawls('REQUESTED')"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Table -->
              <div class="row">
                <div class="col-12">
                  <div
                    v-if="withdrawals.length > 0 && !loading"
                    class="table-responsive mb-0"
                  >
                    <b-table
                      :items="withdrawals"
                      :fields="fields"
                      responsive="sm"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      sort-icon-left
                      :filter="filter"
                      :filter-included-fields="filterOn"
                    >
                    
                      <template v-slot:cell(user)="data">
                        {{ data.item.user.name }}
                        <NewProgressBar v-if="data.item.user.score && data.item.user.score.total_score" :type="'SellerScore'" :valor="data.item.user.score.total_score"/>
                      </template>

                      <template v-slot:[`cell(account.account)`]="data">
                        {{ data.item.account.account }}-{{
                          data.item.account.account_dv
                        }}
                      </template>

                      <template v-slot:[`cell(account.agency)`]="data">
                        {{ data.item.account.agency
                        }}<span v-if="data.item.account.agency_dv"
                          >-{{ data.item.account.agency_dv }}</span
                        >
                      </template>

                      <template v-slot:cell(created_at)="data">
                        {{ data.value | datetime }}
                      </template>

                      <template v-slot:cell(status)="data">
                        <span v-if="data.value === 'REQUESTED'">Solicitado</span>
                      </template>

                      <template v-slot:cell(amount)="data">
                        R$ {{ formatMoney(data.value) }}
                      </template>

                      <template v-slot:cell(id)="data">
                        <div class="actions">
                          <b-button
                            variant="dark"
                            @click="openHistoric(data.item)"
                          >
                            <i class="fas fa-info-circle"></i>
                          </b-button>

                          <b-button
                            variant="success"
                            @click="accept(data.value)"
                          >
                            <i class="fas fa-check"></i>
                          </b-button>
                          
                          <b-button
                            variant="dark"
                            @click="passToAnalyze(data.item)"
                          >
                            <i class="fas fa-exclamation-triangle"></i>
                          </b-button>

                          <b-button variant="danger" @click="deny(data.value)">
                            <i class="fas fa-times"></i>
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>

              <!-- Loading -->
              <div v-if="loading" class="row justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <!-- Pagination -->
              <div v-if="withdrawals.length > 0" class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="withdrawals.length"
                        :per-page="perPage"
                        @change="fetchWithdrawls('REQUESTED')"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Feedback Menssage -->
              <div v-if="withdrawals.length === 0 && !loading"
                class="row justify-content-center"
              >
                <div class="alert alert-primary" role="alert">
                  Sem saques pendentes no momento.
                </div>
              </div>
            </b-tab>
            <b-tab title="Histórico" @click="fetchWithdrawls('HISTORY')">
              <!-- Items per page -->
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="row align-items-center">
                    <div class="col-2 m-0">Mostrar&nbsp;</div>
                    <div class="col-3 m-0 p-0">
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="fetchWithdrawls('HISTORY')"
                      ></b-form-select>
                    </div>
                    <div class="col-3 m-0 p-0">&nbsp;por página</div>
                  </div>
                </div>

                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="search"
                        type="search"
                        placeholder="Pesquisar..."
                        class="form-control form-control-sm ml-2"
                        @input="fetchWithdrawls('HISTORY')"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
                <!-- End Items per page -->
              </div>

              <!-- Table -->
              <div class="row">
                <div class="col-12">
                  <div v-if="withdrawals.length > 0 && !loading"
                    class="table-responsive mb-0"
                  >
                    <b-table
                      :items="withdrawals"
                      :fields="fields"
                      responsive="sm"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      sort-icon-left
                      :filter="filter"
                      :filter-included-fields="filterOn"
                    >

                      <template v-slot:cell(user)="data">
                        {{ data.item.user.name }}
                        <NewProgressBar v-if="data.item.user.score && data.item.user.score.total_score" :type="'SellerScore'" :valor="data.item.user.score.total_score"/>

                      </template>

                      <template v-slot:[`cell(account.account)`]="data">
                        {{ data.item.account.account }}-{{
                          data.item.account.account_dv
                        }}
                      </template>

                      <template v-slot:[`cell(account.agency)`]="data">
                        {{ data.item.account.agency
                        }}<span v-if="data.item.account.agency_dv"
                          >-{{ data.item.account.agency_dv }}</span
                        >
                      </template>

                      <template v-slot:cell(created_at)="data">
                        {{ data.value | datetime }}
                      </template>

                      <template v-slot:cell(status)="data">
                        <span v-if="data.value === 'REQUESTED'">Solicitado</span>
                        <span v-if="data.value === 'ACCEPTED'">Aceitado</span>
                        <span v-if="data.value === 'DENIED'">Recusado</span>
                      </template>

                      <template v-slot:cell(amount)="data">
                        R$ {{ formatMoney(data.value) }}
                      </template>

                      <template v-slot:cell(id)="data">
                        <div class="text-right">
                          <b-button
                            variant="dark"
                            @click="openHistoric(data.item)"
                          >
                            <i class="fas fa-info-circle"></i>
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>

              <!-- Loading -->
              <div v-if="loading" class="row justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <!-- Pagination -->
              <div v-if="withdrawals.length > 0" class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        @change="fetchWithdrawls('HISTORY')"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Feedback Menssage -->
              <div v-if="withdrawals.length === 0 && !loading"
                class="row justify-content-center"
              >
                <div class="alert alert-primary" role="alert">
                  Sem histórico de saques no momento.
                </div>
              </div>
            </b-tab>
            <b-tab title="Em análise"
              @click="fetchWithdrawls('ANALYZE')"
            >
              <!-- Items per page -->
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="row align-items-center">
                    <div class="col-2 m-0">Mostrar&nbsp;</div>
                    <div class="col-3 m-0 p-0">
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="fetchWithdrawls('ANALYZE')"
                      ></b-form-select>
                    </div>
                    <div class="col-3 m-0 p-0">&nbsp;por página</div>
                  </div>
                </div>

                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="search"
                        type="search"
                        placeholder="Pesquisar..."
                        class="form-control form-control-sm ml-2"
                        @input="fetchWithdrawls('ANALYZE')"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Table -->
              <div class="row">
                <div class="col-12">
                  <div
                    v-if="withdrawals.length > 0 && !loading"
                    class="table-responsive mb-0"
                  >
                    <b-table
                      :items="withdrawals"
                      :fields="fields"
                      responsive="sm"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      sort-icon-left
                      :filter="filter"
                      :filter-included-fields="filterOn"
                    >

                      <template v-slot:cell(user)="data">
                        {{ data.item.user.name }}
                        <NewProgressBar v-if="data.item.user.score && data.item.user.score.total_score" :type="'SellerScore'" :valor="data.item.user.score.total_score"/>
                      </template>

                      <template v-slot:[`cell(account.account)`]="data">
                        {{ data.item.account.account }}-{{
                          data.item.account.account_dv
                        }}
                      </template>

                      <template v-slot:[`cell(account.agency)`]="data">
                        {{ data.item.account.agency
                        }}<span v-if="data.item.account.agency_dv"
                          >-{{ data.item.account.agency_dv }}</span
                        >
                      </template>

                      <template v-slot:cell(created_at)="data">
                        {{ data.value | datetime }}
                      </template>

                      <template v-slot:cell(status)="data">
                        <span v-if="data.value === 'ANALYZE'">Em análise</span>
                      </template>

                      <template v-slot:cell(amount)="data">
                        R$ {{ formatMoney(data.value) }}
                      </template>

                      <template v-slot:cell(id)="data">
                        <div class="actions">
                          <b-button
                            variant="dark"
                            @click="openHistoric(data.item)"
                          >
                            <i class="fas fa-info-circle"></i>
                          </b-button>

                          <b-button
                            variant="success"
                            @click="passToRequested(data.item)"
                          >
                            <i class="fas fa-check"></i>
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>

              <!-- Loading -->
              <div v-if="loading" class="row justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <!-- Pagination -->
              <div v-if="withdrawals.length > 0" class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="withdrawals.length"
                        :per-page="perPage"
                        @change="fetchWithdrawls('ANALYZE')"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Feedback Menssage -->
              <div v-if="withdrawals.length === 0 && !loading"
                class="row justify-content-center"
              >
                <div class="alert alert-primary" role="alert">
                  Sem saques pendentes no momento.
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <ModaHistoric :dados="dados" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import WithdrawService from '@services/resources/WithdrawService'
import Money from '@src/mixins/money'
import ModaHistoric from './historic.vue'
import Graph from '@router/views/analysis/graph.vue';
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'

var service = WithdrawService.build()

export default {
  name: 'ListagemSaques',
  page: {
    title: 'Saques',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, ModaHistoric, Graph, NewProgressBar },
  mixins: [Money],
  data() {
    return {
      title: 'Saques',
      withdrawals: [],
      dados: null,
      loading: true,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Saques',
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100],
      search: '',
      filter: '',
      filterOn: [],
      sortBy: 'nomeFantasia',
      sortDesc: false,
      fields: [
        { key: 'user', label: 'Cliente', sortable: true },
        { key: 'account.name', label: 'Titular da conta', sortable: false },
        { key: 'account.cpf_cnpj', label: 'CPF/CNPJ', sortable: false },
        { key: 'user.email', label: 'E-mail', sortable: true },
        { key: 'amount', label: 'Valor', sortable: true },
        { key: 'created_at', label: 'Data', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'account.bank_name', label: 'Banco', sortable: true },
        { key: 'account.account', label: 'Conta', sortable: false },
        { key: 'account.agency', label: 'Agência', sortable: false },
        { key: 'id', label: 'Ações', sortable: false },
      ],
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  },
  mounted() {
    this.fetchWithdrawls('REQUESTED')
  },
  methods: {
    passToAnalyze(item) {
      let idToAccept = item.id;
      Vue.swal({
        title: 'Enviar para análise',
        text: 'Enviar este saque para análise?',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: idToAccept,
            status: 'ANALYZE',
          }

          service
            .update(data)
            .then((resp) => {
              Vue.swal({
                title: 'Saque',
                text: 'Saque enviado para análise!',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.fetchWithdrawls('REQUESTED')
                }
              })
            })
            .catch((err) => {
              console.log(err)
              Vue.swal({
                title: 'Saque',
                text: 'Ocorreu um erro durante o processamento do saque.',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              })
            })
        }
      })
    },
    passToRequested(item) {
      let idToAccept = item.id
      Vue.swal({
        title: 'Enviar para solicitações',
        text: 'Enviar este saque para solicitações?',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: idToAccept,
            status: 'REQUESTED',
          }

          service
            .update(data)
            .then((resp) => {
              Vue.swal({
                title: 'Saque',
                text: 'Saque enviado para solicitações!',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.fetchWithdrawls('ANALYZE');
                }
              })
            })
            .catch((err) => {
              console.log(err)
              Vue.swal({
                title: 'Saque',
                text: 'Ocorreu um erro durante o processamento do saque.',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              })
            })
        }
      })
    },
    openHistoric(item) {
      this.dados = item
      this.$bvModal.show('saques-historico')
    },
    fetchWithdrawls(status) {
      this.loading = true
      this.withdrawals = []

      var data = {
        status: status,
      }

      if (this.search.length > 0) data.search = this.search

      service
        .search(data)
        .then((resp) => {
          this.withdrawals = resp.data
          this.totalRows = resp.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    login(id) {
      let url = (this.isHeaven ? process.env.VUE_APP_HEAVEN_ADM_PAGE : process.env.VUE_APP_ADM_PAGE) + '/admin-login/' + btoa(id)
      window.open(url)
    },
    accept(id) {
      Vue.swal({
        title: 'Autorizar saque',
        text: 'Tem certeza que deseja autorizar este saque?',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: id,
            status: 'ACCEPTED',
          }

          service
            .update(data)
            .then((resp) => {
              Vue.swal({
                title: 'Saque',
                text: 'Saque realizado com sucesso!',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.fetchWithdrawls('REQUESTED')
                }
              })
            })
            .catch((err) => {
              console.log(err)
              Vue.swal({
                title: 'Saque',
                text: 'Ocorreu um erro durante o processamento do saque.',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              })
            })
        }
      })
    },
    deny(id) {
      Vue.swal({
        title: 'Recusar saque',
        text: 'Tem certeza que deseja recusar este saque?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: id,
            status: 'DENIED',
          }

          service
            .update(data)
            .then((resp) => {
              this.fetchWithdrawls('REQUESTED')
            })
            .catch(err => console.error(err))
        }
      })
    },
    refund(id) {
      Vue.swal({
        title: 'Reembolsar',
        text: 'Escreva uma observação para este vendedor',
        type: 'warning',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value.length) {
          let data = {
            id: id,
            status: 'REFUNDED',
            message: result.value,
          }

          service
            .update(data)
            .then((resp) => {
              this.fetchWithdrawls('HISTORY')
            })
            .catch(err => console.error(err))
        }
      })
    },
  },
}
</script>

<style scoped>
.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
